<template>
  <div class="edit-video-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="300px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="params"
        :rules="rules"
        label-width="90px"
        :label-position="labelPosition"
      >
        <!-- <el-form-item label="ID:" prop="id" v-if="type === 'edit'">
          <el-input v-model="params.id" size="small"></el-input>
        </el-form-item> -->
        <el-form-item label="商区码:" prop="districtCode">
          <el-input v-model="params.districtCode" size="small"></el-input>
        </el-form-item>
        <el-form-item label="序列号:" prop="promSeqe">
          <el-input v-model="params.promSeqe" size="small"></el-input>
        </el-form-item>       
        <el-form-item label="域名:" prop="domainName">
          <el-input v-model="params.domainName" size="small"></el-input>
        </el-form-item>        
        <el-form-item label="备注:" prop="remark">
          <el-input v-model="params.remark" size="small"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('form')"
          :loading="flag"
          size="small"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
// import baseConfig from "@/utils/serverUrlConfig";
// import {urlSchemes} from '@/utils/validator'
export default {
  data() {
    return {
      labelPosition: "left",
      dialogVisible: false,
      title: "",
      flag: false,
      type  :'',
      params: {
        id: "", //修改  必填
        districtCode: "", // 添加 必填
        domainName: "",
        remark: "",
        promSeqe:'',
      },
      // 表单验证规则
      rules: {
        id: [{ required: true, message: "请输入ID", trigger: "blur" }],
        districtCode: [
          { required: true, message: "请输入商区码", trigger: "blur" }
        ],
        domainName: [{ required: true, message: "请输入域名", trigger: "blur" }]
      }
    };
  },
  // computed: {
  //   discCode() {
  //     const discCode = this.$store.state.loginModule.userInfo.code;
  //     return discCode.toString();
  //   }
  // },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.flag = true;
          if (this.type ==='add') {
            this.addDomain();
          } else {
            this.updateDomain();
          }
        } else {
          return false;
        }
      });
    },
    // 添加标签
    addDomain() {
      let params=Object.assign({},this.params,{promSeqe: this.params.promSeqe ? this.params.promSeqe : 'ZERO_VALUE',
      })
      API.addDomain(params)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success"
            });
            this.$emit("handlerAgentList");
          } else {
            this.$message.error("添加失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 编辑标签
    updateDomain() {
      let params=Object.assign({},this.params,{id:this.params.id,
      promSeqe: this.params.promSeqe ? this.params.promSeqe : 'ZERO_VALUE',
      })
      API.updateDomain(params)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功",
              type: "success"
            });
            this.$emit("handlerAgentList");
          } else {
            this.$message.error("编辑失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.params = {
        id: "", //修改  必填
        districtCode: "", // 添加 必填
        domainName: "",
        remark: ""
      };
    },
    // 打开编辑域名页、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true;
      this.type = type;
      if (type === "edit") {
        this.title = "修改域名列表";
        this.params.districtCode = data.districtCode;
        this.params.domainName = data.domainName;
        this.params.id = data.id;
        this.params.remark = data.remark;
        this.params.promSeqe = data.promSeqe;
      } else {
        this.title = "新增域名列表";
      }
    }
  }
};
</script>

<style lang="scss">
.edit-video-box {
  .item-box {
    margin-left: 28px;
    width: 100%;
    display: flex;
    .item1 {
      flex: 1;
      .upload {
        position: relative;
        top: 35px;
        left: -90px;
      }
    }
    .item2 {
      flex: 3;
      width: 250px;
      position: relative;
      top: 0px;
      left: -60px;
    }
  }
}
</style>
